import * as _ from 'lodash';
import * as React from 'react';
import { Checkbox, Input, Radio, Select } from 'antd';
import { FormItem } from '../../../../components/Form';

export interface IGeneralProps {
  attribute: GQL.IAttribute;
  currentLanguage: string;
  onChange: Function;
}

export default class General extends React.Component<IGeneralProps> {

  public render() {
    const { attribute, currentLanguage } = this.props;

    return (
      <div>
        <FormItem label={'Title'} required={true}>
          <Input
            name={'title'}
            required={true}
            autoFocus={true}
            placeholder="Internal title. For example &quot;Size - Clothes&quot;"
            addonBefore={'Internal'}
            value={attribute.title}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'Name'} required={true}>
          <Input
            name={'name'}
            required={true}
            addonBefore={currentLanguage}
            placeholder="Attribute's name in eshop"
            value={(attribute.name || {})[currentLanguage]}
            onChange={e => this.props.onChange(e, currentLanguage)}
          />
        </FormItem>
        <FormItem label={'Slug'} required={true}>
          <Input
            name={'slug'}
            required={true}
            addonBefore={currentLanguage}
            placeholder="Slug in the eshop (eg. in filter-url)"
            value={(attribute.slug || {})[currentLanguage]}
            onChange={e => this.props.onChange(e, currentLanguage)}
          />
        </FormItem>
        <FormItem label={'Type'} required={true}>
          <Select
            value={attribute.type || 'text'}
            showSearch={false}
            placeholder={'Type'}
            style={{ width: '100%' }}
            onChange={e => this.props.onChange({ target: { name: 'type', value: e } })}
          >
            <Select.Option value={'text'}>Text</Select.Option>
            <Select.Option value={'custom'}>Custom</Select.Option>
          </Select>
        </FormItem>
        <FormItem label={'Priority'}>
          <Input
            name={'priority'}
            placeholder="Priority"
            type={'number'}
            defaultValue={attribute.priority ? attribute.priority.toString() : ''}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        {/* <FormItem>
          <Checkbox
            name={'isVisual'}
            checked={attribute.isVisual !== undefined ? attribute.isVisual : false}
            onChange={e => this.props.onChange(e)}
          >
            Is visual
          </Checkbox>
        </FormItem> */}

        {/* <FormItem label={'System tags'} extra={'For example "size"'}>
          <Select
            mode="tags"
            defaultValue={attribute.tags}
            style={{ width: '100%' }}
            placeholder=""
            // onChange={(tags: string[]) => this.onChange('tags', tags, false)}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem> */}
        {/* <FormItem required={true} label={'Definition'}>
            <Radio.Group
              disabled={
                attribute.values &&
                attribute.values.length > 0 || false
              }
              onChange={val => container.onChangeDefinitionType(val.target.value)}
              defaultValue={attributeDetail.state.definitionType}
            >
              <Radio.Button value={'single'}>Single</Radio.Button>
              <Radio.Button value={'custom'}>Custom</Radio.Button>
            </Radio.Group>
            {attributeDetail.state.definitionType &&
              attributeDetail.state.definitionType === 'custom' && (
                <DynamicInputs
                  editable={true}
                  disabled={
                    attributeDetail.state.attribute.values &&
                    attributeDetail.state.attribute.values.length > 0
                  }
                  defaultFields={attributeDetail.state.attribute.definition}
                  onChange={f => this.onChange('definition', f, true)}
                />
              )}
          </FormItem> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Attributes/AttributeDetail/components/General.tsx